import React from 'react'
import { connect } from "react-redux";
import { Modal, Form, Button } from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import { sendStaffAppMetaData } from "../staffApp/eventTriggers"
import withFetchHook from "../withFetchHook";
import Creatable from "react-select/lib/Creatable";

class TestFormModalC extends React.Component {
  kindOptions = [
    { label: 'COVID-19', value: 'COVID-19' },
    { label: 'TB (Tuberculosis)', value: 'Tuberculosis' },
    { label: 'Hepatitis C', value: 'Hepatitis C' },
  ]
  resultOptions = [{ label: 'Positive', value: 'positive' },{ label: 'Negative', value: 'negative' }]

  setDefaultStaffAppMetaData =  () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  updateTests(test){
    return this.props.fetch(`/organizations/${this.props.organizationName}/residents/${this.props.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          medical_tests_attributes: [test]
        }
      })
    })
  }

  saveTest = () => {
    return this.updateTests(this.props.test).then((data) => {
      this.props.updateTests(data.medical_tests)
      if (this.props.isStaffApp) {
        alert('Test changes saved.')
        this.setDefaultStaffAppMetaData()
      }
      this.props.handleClose()
    })
  }

  deleteTest = () => {
    this.updateTests({
      id: this.props.test.id,
      _destroy: true
    }).then((data)=>{
      this.props.updateTests(data.medical_tests)
    }).then(() => {
      if (this.props.isStaffApp) {
        alert('Test successfully deleted.')
        this.setDefaultStaffAppMetaData()
      }
      this.props.handleClose()
    })
  }

  saveTestFunction = (e) => {
    this.props.dispatch(this.saveTest())
  }

  componentDidMount() {
    document.addEventListener('saveTest', this.saveTestFunction) 
  }

  componentWillUnmount() {
    document.removeEventListener('saveTest', this.saveTestFunction)
  }

  render() {
    const { show, handleClose, isStaffApp, test, action, updateField, hasDelete, hasEdit } = this.props
    const { kindOptions, saveTest, deleteTest } = this
    return(
      <Modal show={show} onHide={handleClose}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Test</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="testKind">
                <Form.Label>Kind</Form.Label>
                <Creatable
                 value={kindOptions.find(option => option.value == test.kind)}
                 options={kindOptions}
                 onChange={(option) => updateField('kind', option.value) }/>
              </Form.Group>

              <Form.Group controlId="testPerformedOn">
                <Form.Label>Performed On</Form.Label>
                <DatePicker
                  selected={test.performed_on ? moment(test.performed_on) : null}
                  className="form-control"
                  onChange={(date) => updateField( 'performed_on', date ? date.format("YYYY-MM-DD") : null)} />
              </Form.Group>

              <Form.Group controlId="testResult">
                <Form.Label>Result</Form.Label>
                <Select
                  value={this.resultOptions.find(option => option.value == test.result)}
                  options={this.resultOptions}
                  onChange={(option) => updateField('result', option.value) }/>
              </Form.Group>

              <Form.Group controlId="testNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  className="form-control"
                  value={test.notes}
                  onChange={(e) => updateField( 'notes', e.target.value)} />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Kind</Form.Label>
                <div className="form-control-plaintext">{test.kind || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Performed On</Form.Label>
                <div className="form-control-plaintext">{test.performed_on ? moment(test.performed_on).format('MM/DD/YYYY') : 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Result</Form.Label>
                <div className="form-control-plaintext">{test.result || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <div className="form-control-plaintext">{test.notes || 'N/A'}</div>
              </Form.Group>
            </>
          )}



          {
            !isStaffApp ?
            <Modal.Footer>
              {
                action === "edit" && hasDelete &&
                <Button
                  variant="outline-danger"
                  onClick={() => deleteTest(test) }>
                  Delete
                </Button>
              }
              <Button
                variant="info"
                onClick={() => {
                  saveTest(test)
                }}>
                {action === "edit" ? "Update" : "Create"}
              </Button>
            </Modal.Footer> :
            <>
              {
                action === 'edit' && hasDelete &&
                <div className="p-3">
                  <Button 
                    onClick={()=>deleteTest(test)}
                    className="w-100" 
                    variant="outline-danger">
                    Delete
                  </Button>
                </div>
              }
            </>
          }
        </Modal.Body>
      </Modal>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.testModal.show,
    action: state.ui.action,
    isStaffApp: state.config.isStaffApp,
    test: state.ui.testModal.test,
    organizationName: state.organization.name,
    id: state.resident.id,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab=> tab.detail == 'tests'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit')
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleClose: () => dispatch({type: 'CLOSE_TEST_FORM_MODAL'}),
    updateField: (name, value) => dispatch({ type: "UPDATE_TEST_FIELD", payload: { name, value } }),
    updateTests: (tests) => dispatch({ type: "UPDATE_TESTS", payload: { tests } }),
    dispatch: (func) => dispatch(func()),
  }
}

export const TestFormModal = withFetchHook(connect(mapStateToProps, mapDispatchToProps)(TestFormModalC));
